export default __webpack_public_path__ + "static/media/2.a3fcf692.png";